export default __webpack_public_path__ + "static/media/Menu.fe2a050f.jpeg";